export default __webpack_public_path__ + "static/media/errorFilledRed.42dfde5a.svg";